<template>
  <v-banner :value="show">
    <template v-slot:icon>
      <template v-if="$slots.icon">
        <slot name="icon" />
      </template>
      <v-icon v-else large color="primary">
        $freshvue-cookie
      </v-icon>
    </template>

    {{ $t('fresh-vue.CookieConsent.message') }}

    <template v-slot:actions>
      <v-btn text color="primary" @click="closeBanner">
        {{ $t('fresh-vue.misc.ok') }}
      </v-btn>
    </template>
  </v-banner>
</template>

<script>
import Cookies from 'js-cookie'

import { VBanner, VIcon, VBtn } from 'vuetify/lib'

export default {
  name: 'CookieConsent',

  components: {
    VBanner,
    VIcon,
    VBtn
  },

  props: {
    cookieKey: {
      type: String,
      required: false,
      default: 'CookieConsent'
    }
  },

  data() {
    return {
      show: false
    }
  },

  mounted() {
    this.show = Cookies.get(this.cookieKey) !== 'true'
  },

  methods: {
    closeBanner() {
      Cookies.set(this.cookieKey, 'true')
      this.show = false
      this.$emit('close')
    }
  }
}
</script>
